// extracted by mini-css-extract-plugin
module.exports = {"poweredBy":"poweredBy_poweredBy__2iBTt","text":"poweredBy_text__3x7nz","link":"poweredBy_link__3fPl3"};